import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../shared/material';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ...MATERIAL_IMPORTS
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  username = '';
  password = '';
  error = '';
  hidePassword = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  login(): void {
    this.error = '';

    const username = this.username.trim();
    const password = this.password;

    if (!username || !password) {
      this.error = 'Bitte geben Sie Ihren Benutzernamen und Ihr Passwort ein.';
      return;
    }

    this.authService.login(username, password, 11).subscribe({
      next: (response) => {
        if (typeof window !== 'undefined' && window.localStorage) {
          this.authService.storeSession(response);
        }

        this.router.navigate(['/showsList']);
      },
      error: (err) => {
        console.error('Login failed:', err);
        this.error = 'Benutzername oder Passwort ist falsch.';
      }
    });
  }
}